import { useContext, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { AppContext } from "../../../AppContext";
import { Result } from "bloggers-backend/lib/domain/Result";

export function useDeleteMany(event: string, cacheName: string) {
  const [deleting, setDeleting] = useState(false);
  const {notificationsService, client} = useContext(AppContext);
  const queryClient = useQueryClient();

  async function deleteEntities(ids: string[]) {
    setDeleting(true);

    const result = await client<{}, Result<unknown>>({
      event,
      data: {ids}
    });

    setDeleting(false);

    if (result.success) {
      notificationsService.notify({
        severity: 'success',
        message: `${ids.length} deleted`
      });
      await queryClient.invalidateQueries([cacheName]);
    } else {
      notificationsService.notify({
        severity: 'error',
        message: JSON.stringify(result.errors)
      });
    }
  }

  return {deleting, deleteEntities};
}
